import { isEpsFormat, getSizeFromImageId, getUrlPartsEpsFormat, getUrlPartsZoomFormat } from './utils';
/**
 * Get EPS parts from and image URL
 * @param url - Image URL
 * @returns EPS parts
 */
export const getEpsImagePartsFromUrl = (url) => {
    const isEps = isEpsFormat(url);
    const parts = isEps ? getUrlPartsEpsFormat(url) : getUrlPartsZoomFormat(url);
    if (!parts)
        throw new Error('Unsupported format');
    const [, protocol, baseUrl, zoomId, imageIdOrSize, suffixWithCase, queryString] = parts;
    const imageId = imageIdOrSize;
    const sizeIsExplicit = !isEps;
    const size = sizeIsExplicit
        ? parseInt(imageIdOrSize, 10)
        : getSizeFromImageId(imageId);
    const suffix = suffixWithCase?.toLowerCase();
    return {
        protocol,
        baseUrl,
        zoomId,
        size,
        suffix,
        queryString
    };
};
